import { string, regex, seq, seqMap, whitespace, alt, lazy } from 'parsimmon';

const bbcodeOpenBegin = string('[');
const bbcodeCloseBegin = string('[/');
const bbcodeEnd = string(']');

const htmlOpenBegin = string('<');
const htmlEnd = string('>');
const htmlContent = regex(/[^>]+/);

const bbcodeType = regex(/\w+/);
const bbcodeValue = regex(/[^\]]+/);
const singleTagValues = regex(/\[(?!\/)(.*?)\]/, 1);
const bbcodeValueNoQuotes = regex(/[^\]'"]+/);
const bbcodeAttrVal = regex(/[^\] ]+/);

const quote = regex(/['"]/);
const words = regex(/[^\[<]+/);

// Handle stray html tags
const htmlTag = seqMap(htmlOpenBegin, htmlContent, htmlEnd,
	(a, b, c) => {
		switch (b) {
			case 'br':
				return '\n';
			default:
				return '';
		}
	}
);

const bbcodeQuotedValue = seqMap(quote, bbcodeValueNoQuotes, quote,
	(_, val, __) => {
		return val;
	}
);

const attrValue = seq(regex(/[= ]/), bbcodeQuotedValue.or(bbcodeValue));

// OPEN TAGS [TAG(=VALUE)]
const bbcodeOpenTag = seqMap(bbcodeOpenBegin, bbcodeType, attrValue.atMost(1), bbcodeEnd,
	(_, type, attrs, __) => {
		return {
			tag: type.toLowerCase(),
			attributes: (attrs.length > 0) ? attrs[0][1] : []
		};
	}
).desc('bbcode open tag');

// ATTRIBTE KEY VALUE PAIRS KEY=VAL
const bbcodeAttrPair = seq(whitespace, bbcodeType.skip(string('=')), bbcodeAttrVal)
	.map((_, key, val) => {
		return {
			key: key,
			val: val
		};
	}
).desc('bbcode multi attribute pair');

// OPEN TAGS [TAG (KEY=VALUE)+]
const bbcodeOpenMultiParmTag = seqMap(bbcodeOpenBegin, bbcodeType, bbcodeAttrPair.atLeast(1), bbcodeEnd,
	(_, type, pairs, __) => {
		return {
			tag: type.toLowerCase(),
			attributes: pairs
		};
	}
).desc('bbcode open tag (multi param)');

// CLOSE TAGS [/TAG]
const bbcodeCloseTag = seqMap(bbcodeCloseBegin, bbcodeType, bbcodeEnd,
	(_, type, __) => {
		return {
			tag: type.toLowerCase()
		};
	}
).desc('bbcode close tag');

// SINGLE TAG [TAG]
const nobbcodeSingleTag = seqMap(singleTagValues,
	( content ) => {
		return {
			open: {
				tag: content,
				attributes: null
			},
			content: null,
			close: null
		};
	}
).desc('no bbcode single tag');

const content = lazy(function() {
	return alt(htmlTag, words, bbcodeBlock, nobbcodeSingleTag).many();
});

const bbcodeBlock = seqMap(alt(bbcodeOpenTag, bbcodeOpenMultiParmTag), content, bbcodeCloseTag,
	(open, mid, close) => {
		return {
			open: open,
			content: mid,
			close: close
		};
	}
);

export default content;




// WEBPACK FOOTER //
// ./src/utils/bbcode/BBCodeParser.js